import { render, staticRenderFns } from "./CheckboxControl.vue?vue&type=template&id=c9567836&scoped=true"
import script from "./CheckboxControl.vue?vue&type=script&lang=js"
export * from "./CheckboxControl.vue?vue&type=script&lang=js"
import style0 from "./CheckboxControl.vue?vue&type=style&index=0&id=c9567836&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9567836",
  null
  
)

export default component.exports